import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AppService } from 'src/app/service/app.service';
import { UserDetailsService } from 'src/app/service/user-details.service';
import { ToastrService } from 'ngx-toastr';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { config } from 'src/app/config/config';
declare var $: any;

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.css']
})
export class AddUserComponent implements OnInit, AfterViewInit {
  Checkedstatus: any;
  submitted = false;
  adduserForm: FormGroup;
  user: any = {};
  action: string = 'add';
  config: any = config;
  entityTypeData: any = [];
  userTypeData: any = [];
  entityCodeData: any = [];
  message: string;
  userDetails: any;
  disableEntity: boolean = true;
  disableStatus: boolean = false;
  menuCode = 'userList';
  access: any = {};
  approvalForm: FormGroup;

  constructor(private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private appService: AppService,
    private userDetailsService: UserDetailsService,
    private router: Router,
    private toastr: ToastrService,
    private cdref: ChangeDetectorRef,
    private titleService: Title) {
    this.route.queryParams.subscribe(params => {
      if (params['id']) {
        this.user = this.userDetailsService.getUserById(params['id']);
      }
    });
  }

  get f() { return this.adduserForm.controls; }

  ngOnInit(): void {
    this.titleService.setTitle('User Management');
    this.getEntityTypeData();
    this.userTypeData = this.config.data.userTypeData;
    this.userDetails = this.userDetailsService.getUserDetails();
    this.access = this.userDetailsService.checkUserAccess(this.menuCode);
  
    if (this.access === undefined || this.access.isAccessAllowed != 'Y') {
      this.router.navigate(['/']);
      this.toastr.error("Unauthorize to access this page !");
    }
    this.approvalForm = this.formBuilder.group({
      comment: [null]
    });

    if (this.user && this.user.userId) {
      this.action = 'update';
      this.adduserForm = this.formBuilder.group({
        userLoginId: [this.user.userLoginId, [Validators.required, Validators.pattern("^[a-zA-Z0-9]{1}[a-zA-Z0-9_]{4,}$")]],
        entityType: [this.user.entityType, Validators.required],
        entityCode: [this.user.entityCode, Validators.required],
        userName: [this.user.userName, [Validators.required]], // Validators.pattern(".*[a-zA-Z]+.*")]],
        userType: [this.user.userType, Validators.required],
        userEmail: [this.user.userEmail, [Validators.required, Validators.email]],
        userMobile: [this.user.userMobile, [Validators.required, Validators.pattern("^[6-9]{1}[0-9]{9}$")]],
        isActive: [this.user.isActive, Validators.required],
        isDeleted: [this.user.isDeleted, Validators.required],
        comments: [this.user.comments]
      });
    } else {
      this.action = 'add';
      this.adduserForm = this.formBuilder.group({
        userLoginId: [null, [Validators.required, Validators.pattern("^[a-zA-Z0-9]{1}[a-zA-Z0-9_]{4,}$")]],
        entityType: [this.userDetails.entityType != 'ADMIN' ? this.userDetails.entityType : '', Validators.required],
        entityCode: [this.userDetails.entityType != 'ADMIN' ? this.userDetails.entityCode : '', Validators.required],
        userName: [this.userDetails.entityType != 'ADMIN' ? this.userDetails.userName : null, [Validators.required]], // Validators.pattern(".*[a-zA-Z]+.*")]],
        userType: ['', Validators.required],
        userEmail: [null, [Validators.required, Validators.email]],
        userMobile: [null, [Validators.required, Validators.pattern("^[6-9]{1}[0-9]{9}$")]],
        isActive: ['Y', Validators.required],
        comments: [this.user.comments]
      });
    }

    this.access = this.userDetailsService.checkUserAccess(this.menuCode);
    // if (this.access.accessType === "R" || this.access.roleId == 2) {
    //   this.action = 'view';
    //   this.adduserForm.disable();
    // }
    if (this.userDetails.entityType == 'ADMIN') {
      this.disableEntity = false;
    }
    if (this.disableEntity || this.action == 'view' || this.action == 'update') {
      this.adduserForm.get('entityType').disable();
      this.adduserForm.get('entityCode').disable();
    }
    this.cdref.detectChanges();
    $('.selectpicker').selectpicker('refresh');
  }

  ngAfterViewInit() {
    $('.selectpicker').selectpicker();
  }

  getEntityTypeData() {
    this.appService.getAutoPopulatedUserValues().pipe(catchError((error: any) => {
      this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
      if (error.status != 200) {
        return throwError(error.error);
      }
    })).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.entityTypeData = response.data[0].userCreationDropdown;
        if (this.action == 'update' || this.action == 'view') {
          this.entityCodeData = this.entityTypeData.find(data => data.entityType == this.user.entityType)?.entityAndCompanyBeans;
          this.f.entityCode.setValue(this.user.entityCode);
          this.f.userType.setValue(this.user.userType);
        } else if (this.userDetails.entityType != 'ADMIN') {
          this.entityCodeData = this.entityTypeData.find(data => data.entityType == this.userDetails.entityType)?.entityAndCompanyBeans;
          this.f.entityCode.setValue(this.userDetails.entityCode);
        }
        this.cdref.detectChanges();
        $('.selectpicker').selectpicker('refresh');
      } else {
        this.toastr.error(response.message);
      }
    })
  }

  onSubmit() {
    this.submitted = true;
    let requestObject = {
      "userId": this.user.userId || null,
      "userLoginId": this.f.userLoginId.value,
      "userName": this.f.userName.value,
      "entityCode": this.f.entityCode.value,
      "entityType": this.f.entityType.value,
      "userEmail": this.f.userEmail.value,
      "userMobile": this.f.userMobile.value,
      "userType": this.f.userType.value,
      "isActive": this.f.isActive.value,
      "isDeleted": this.f.isDeleted ? this.f.isDeleted.value : 'N',
      "checkedBy": this.user.checkedBy || null,
      "checkedDate": this.user.checkedDate || null,
      "createdBy": this.user.createdBy || this.userDetailsService.getUserDetails().userId, //localStorage.getItem('username'), 
      "createdDate": this.user.createdDate || new Date(),
      "lastModifiedBy": this.userDetailsService.getUserDetails().userId, //localStorage.getItem('username'), 
      "lastModifiedOn": new Date(),
      approval: null
    };

    if (this.action == 'add') {
      this.appService.addUser(requestObject).pipe(catchError((error: any) => {
        this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
        this.submitted = false;
        if (error.status != 200) {
          return throwError(error.error);
        }
      })).subscribe((response: any) => {
        if (response.statusCode == 200) {
          this.message = 'User created successfully';
          this.toastr.success(this.message);
          this.router.navigate(['../'], { relativeTo: this.route, skipLocationChange: true });
        } else {
          this.toastr.error(response.message);
          this.submitted = false;
        }

      })
    } else {
      this.appService.updateUser(this.action, requestObject).pipe(catchError((error: any) => {
        this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
        this.submitted = false;
        if (error.status != 200) {
          return throwError(error.error);
        }
      })).subscribe((response: any) => {
        if (response.statusCode == 200) {
          this.message = 'User updated Successfully.';
          this.toastr.success(this.message);
          this.router.navigate(['../'], { relativeTo: this.route, skipLocationChange: true });
        } else {
          this.message = response.message;
          this.toastr.error(this.message);
        }
      })
    }
  }

  selectEntityType() {
    if (this.userDetails.entityType == 'ADMIN') {
      this.f.entityCode.setValue('ADMIN');
      this.f.userName.setValue('');
    }
    this.entityCodeData = this.entityTypeData.find(data => data.entityType == this.f.entityType.value).entityAndCompanyBeans;
    this.cdref.detectChanges();
    $('.selectpicker').selectpicker('refresh');
  }

  selectEntityCode() {
    this.f.userName.setValue(this.entityCodeData.find(data => data.entityCode == this.f.entityCode.value).userName);
  }

}
